module.exports = __webpack_public_path__ + "static/media/mom_daughter_face_mask.8d4fd569.png";